/**jquery工具方法**/
$.extend($, {
  // 时间戳转化时间格式
  formatTimeStamp(time, format) {
    if (!time) {
      return ''
    }
    if (isNaN(time)) {
      return ''
    }
    // 定义一个默认的时间格式 或者 选传递过来的
    format = format || 'yyyy-MM-dd hh:mm:ss'
    // 转换时间 传递秒数 转换成毫秒
    let date = new Date(time * 1000)
    // key值可以当正则使用
    let o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
    }
    // 因为年最大可以为4位 但是月日时分最大为2位
    // 所以需要单独取出来

    // RegExp.$1 一旦使用过正则匹配 那RegExp.$1 $2 $3就可以取出对应的匹配组
    if (/(y+)/.test(format) || /(Y+)/.test(format)) {
      format = format.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      )
    }
    // RegExp.$1.length == 1 因为如果传递时间格式2个代表2位 1个代表1位
    // 2位不够时需要用0填充
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return format
  },

  // 剩余时间
  formatTimeLength(times) {
    if (!times)
      return {
        date: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      }
    times = Math.floor(times)
    //当前的时间
    let seconds = times % 60
    let minutes = Math.floor(times / 60) % 60
    let hours = Math.floor(times / 60 / 60) % 24
    let date = Math.floor(times / 60 / 60 / 24)
    return {
      date: $.fullZero(date),
      hours: $.fullZero(hours),
      minutes: $.fullZero(minutes),
      seconds: $.fullZero(seconds),
    }
  },

  // url参数
  urlParameter: (function () {
    let url = location.href.split('?')[1]
    let urlData = {}
    if (url) {
      url = url.split('#')[0]
      let temp = url.split('&')
      for (let i = 0; i < temp.length; i++) {
        let t = temp[i].split('=')
        urlData[t[0]] = decodeURI(t[1])
      }
    }
    return urlData
  })(),

  // url参数 或者 对象 转换为 ?***&**
  urlParameterFormat(parameter) {
    parameter = parameter || $.urlParameter
    let result = ''
    for (var i in parameter) {
      const item = parameter[i]
      result += `${!result ? '?' : '&'}${i}=${item}`
    }
    return result
  },

  // 价格分割
  priceSplit(price) {
    let newPrice = '' + Math.abs(price)
    const isSign = price < 0 ? '-' : ''
    const temp = newPrice.split('.')
    const len = temp[0].length
    if (len > 3) {
      let i = 2
      let arr = temp[0].split('').reverse()
      while (i < len) {
        arr[i] = `,${arr[i]}`
        if (!arr[i + 1]) break
        i += 3
      }
      newPrice =
        arr.reverse().join('').replace(/^,/, '') +
        (temp[1] ? `.${temp[1]}` : '')
    }
    return isSign + newPrice
  },

  // 转义html
  transCharacterEntities(text) {
    if (!text) return
    return text
      .replace(/&/gi, '&amp;')
      .replace(/</gi, '&lt;')
      .replace(/>/gi, '&gt;')
      .replace(/'/gi, "'")
      .replace(/"/gi, '"')
  },

  // 小于10填充0
  fullZero(value) {
    return value < 10 ? `0${value}` : value
  },

  clearLoginInfo(isClearAll = true) {
    if (isClearAll) {
      window.localStorage.clear()
      window.sessionStorage.clear()
      document.cookie = `phone=;path=/;expires=${new Date(0).toUTCString()}`
      document.cookie = `password=;path=/;expires=${new Date(0).toUTCString()}`
    }
    document.cookie = `PHPSESSID=;path=/;expires=${new Date(0).toUTCString()}`
    document.cookie = `userKey=;path=/;expires=${new Date(0).toUTCString()}`
    window.location.reload()
  },

  replaceImgExt(value, ext) {
    let result
    const regExp = new RegExp('\\?{1}\\w+(\\/?\\w*)*', 'i')

    // 存在后缀直接替换（兼容旧数据）
    if (ext) {
      result = `${value}${ext}`
    } else if (regExp.test(value)) {
      result = value.replace(regExp, '?imageView2/1/w/400/h/225')
    } else {
      // 否则 直接添加后缀
      result = `${value}?imageslim`
    }
    return result
  },

  //运行环境判断
  getEnv() {
    const host = location.host
    let env = {
      URL: '',
      ENV: '',
    }
    if (/dingdingkaike.cn/.test(host)) {
      env = {
        url: 'https://www.dingdingkaike.cn',
        teacherUrl: 'https://teacher.dingdingkaike.com',
        ENV: 'prod',
      }
    } else if (/release-home/.test(host)) {
      env = {
        url: 'https://release-home.dingdingkaike.com',
        teacherUrl: 'https://teacher-release.dingdingkaike.com',
        ENV: 'release',
      }
    } else {
      env = {
        url: 'https://test-home.dingdingkaike.com',
        teacherUrl: 'https://teacher-test.dingdingkaike.com',
        ENV: 'test',
      }
    }
    return env
  },

  // 免费试用跳转
  registerPage(nodeClass) {
    let phoneNumber
    let ext = '/#/login?t=register&source=1'
    try {
      phoneNumber = document.querySelector(nodeClass).value || ''
      if (phoneNumber) {
        ext += `&phone=${phoneNumber}`
      }
    } catch (e) {}
    window.open(`${$.getEnv().teacherUrl}${ext}`)
  },

  //打开自定义大小的窗口在线咨询
  open_win() {
    try {
      window.open(
        'http://p.qiao.baidu.com/cps/chat?siteId=12909305&userId=11134406&siteToken=b4f8f59b22d93e143bec6f3cf289abee',
        '_blank',
        'toolbar=yes,location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=800, height=600'
      )
    } catch (e) {}
  },

  // url参数
  urlParameter: (function () {
    let url = location.href.split('?')[1]
    let urlData = {}
    if (url) {
      url = url.split('#')[0]
      let temp = url.split('&')
      for (let i = 0; i < temp.length; i++) {
        let t = temp[i].split('=')
        urlData[t[0]] = decodeURI(t[1])
      }
    }
    return urlData
  })(),
})
